import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { thunkGoToGameGuidePage } from '../../../redux/actions/gameGuideActions';
import { useAppDispatch } from '../../../redux/store';
import { SUBTLE_MODAL_TEXT_COLOR } from '../../../styles/colors';
import { FormControlContainer } from '../../formControlContainer';
export const ClientSettingModalItem = ({ settingName, settingDescription, buttonLabel, onClick, onClose, gameGuidePageType }) => {
    const dispatch = useAppDispatch();
    const onClickMoreInfo = useCallback(() => {
        if (!gameGuidePageType) {
            return;
        }
        onClose();
        dispatch(thunkGoToGameGuidePage(gameGuidePageType));
    }, [onClose, dispatch, gameGuidePageType]);
    return (_jsxs(FormControlContainer, { "aria-label": settingName, children: [_jsxs("div", { css: css `
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 5px;
        `, children: [_jsx("div", { css: css `
            flex-grow: 1;
          `, children: _jsx(Typography, { component: 'div', children: _jsx("span", { "aria-hidden": true, children: settingName }) }) }), _jsx("div", { children: _jsx(Button, { variant: 'contained', onClick: onClick, "aria-label": `${settingName}: ${buttonLabel}`, children: buttonLabel }) })] }), _jsx(Typography, { component: 'div', variant: 'subtitle2', css: css `
          color: ${SUBTLE_MODAL_TEXT_COLOR};
        `, children: settingDescription }), gameGuidePageType && (_jsx(Button, { size: 'small', variant: 'outlined', onClick: onClickMoreInfo, children: "More Info" }))] }));
};
